var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":this.IsLoading,"can-cancel":false,"enforce-focus":false,"is-full-page":_vm.fullPage},on:{"update:active":function($event){return _vm.$set(this, "IsLoading", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }